import client from "../../backend-api-client"

import {
  RegisterMutationVariables,
  RegisterMutation,
  RegisterDocument,
  RegistrationInput,
  VerifyMutationVariables,
  VerifyMutation,
  VerifyDocument,
  VerificationInput,
} from "../../backend-api"

export const userRegisterMutation = (input: RegistrationInput) =>
  client.mutate<RegisterMutation, RegisterMutationVariables>({
    mutation: RegisterDocument,
    variables: {
      input,
    },
  })

export const userVerifyMutation = (input: VerificationInput) =>
  client.mutate<VerifyMutation, VerifyMutationVariables>({
    mutation: VerifyDocument,
    variables: {
      input,
    },
  })
